export default __webpack_public_path__ + "static/media/dead.4e59eb19.mp3";